import { bl_fi_mst_ecomsync_branch_RowClass } from '../../dbschema/bl_fi_mst_ecomsync_branch';
import {BaseContainerModel} from '../base-container.model';

export class EcomsyncBranchContainerModel extends BaseContainerModel {
  bl_fi_mst_ecomsync_branch: bl_fi_mst_ecomsync_branch_RowClass = new bl_fi_mst_ecomsync_branch_RowClass();
}
